import Message from '@/Messages/Message';
import ComponentManager from '@/Management/ComponentManager';

export default class ListViewEnteredMessage extends Message {

    public constructor(params: any) {
        super(params);
    }
}

ComponentManager.setMessage('ListViewEnteredMessage', ListViewEnteredMessage, 'RADPresentation.HTMLClient.DefaultViewExtensions');